@import (reference) '../../../../../../../constants/spacing.module.less';

.edit-amount-summary-modal {
  font-size: 14px;
  line-height: 18px;
  color: var(--default--text-color--17);
}

.edit-amount-summary-modal-content {
  padding: @space-16;
}

.amounts-table {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.instructions {
  align-items: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: var(--default--text-color--16);
  padding: 8px;
}

.cell {
  display: flex;
  padding: @space-0 @space-8;
  gap: @space-8;
  width: 112px;
  height: 64px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.header-row {
  background-color: var(--default--background-color--14);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  .header-cell {
    display: flex;
    padding: @space-8;
    width: 688px;
    height: 40px;
  }
}

.body-row {
  font-size: 14px;
  line-height: 21px;
  border-bottom: 1px solid var(--table--border-color--2);
  border-left: 1px solid var(--table--border-color--2);
  border-right: 1px solid var(--table--border-color--2);
  .read-only-currency {
    width: 100%;
    justify-content: right;
    display: flex;
  }
  .input {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    height: 34px;
    width: 96px;
  }
  &.selected {
    background-color: var(--primary--selected--background-color--4);
  }
  &:last-child {
    border-top: 1px solid var(--default--border-color--16);
    .cell {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 688px;
      height: 40px;
    }
    .shipment-cell {
      justify-content: flex-start;
      padding: @space-0 @space-8;
    }
  }
}

.shipment-cell {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 128px;
  padding: @space-0 @space-8;
  height: 64px;
}

.currency-symbol {
  padding-top: 0;
}
